import { apiFetch, withAuth } from "../common/api";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * @param {AccessToken} accessToken
 * @returns {User | null}
 */
export async function me(accessToken) {
  const headers = accessToken
    ? { Authorization: `${accessToken.tokenType} ${accessToken.accessToken}` }
    : {};
  const resp = await fetch(`${HOST}/api/v1/users/me`, {
    method: "GET",
    headers,
  });

  if (resp.status == 401) {
    return null;
  }

  if (resp.status != 200) {
    throw await resp.text();
  }
  return await resp.json();
}

/**
 * @param {object} formData
 * @returns {Promise<Response>}
 */
export async function login(formData) {
  return await fetch(`${HOST}/api/v1/token`, {
    method: "POST",
    body: formData,
  });
}

/**
 * @param {object} accessToken
 * @returns {Promise<Array<User>>}
 */
export async function fetchAll(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/users`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  const data = await resp.json();
  console.log("Fetched", data, "users");
  return data;
}

/**
 * @param {object} accessToken
 * @param {UpdateUserRequest} req
 * @throws {string}
 */
export async function update(accessToken, req) {
  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/users`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}

/**
 * @param {object} accessToken
 * @param {RegisterUserRequest} req
 * @throws {string}
 */
export async function save(accessToken, req) {
  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/users/register`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}

/**
 * @param {RestorePasswordRequest} req
 */
export async function restorePassword(req) {
  const resp = await fetch(`${HOST}/api/v1/users/restore-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  });

  if (resp.status != 200) {
    throw await resp.text();
  }
}

/**
 * @param {object} accessToken
 * @param {number} userId
 */
export async function archive(accessToken, userId) {
  const opts = { method: "DELETE" };
  const resp = await apiFetch(
    `${HOST}/api/v1/users/${userId}`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status !== 200) {
    throw await resp.text();
  }
}
